/**
 * StoryColumn - the story's panels, one under another: the cast, the board,
 * the clocks, then the director's Announce box (v9.7.0), Time passes and
 * decision timer, and the GM's notes. What each offers depends on who
 * directs (`story.canDirect`).
 *
 * @param {object} props
 * @param {{ clocks: object, board: object, cast: object, canDirect: boolean }} props.story
 */
import common from '../../styles/common.module.css';
import styles from '../../styles/Story.module.css';
import BoardPanel from './BoardPanel';
import CastPanel from './CastPanel';
import GmNotes from './GmNotes';
import { TimerControl } from './DecisionTimer';
import ClocksPanel from './ClocksPanel';
import Announce from './Announce';
import { useChatContext } from '../../contexts/ChatContext';

/**
 * Time passes: one beat for everyone - timed conditions count down, what
 * burns burns - with nobody taking a turn. The director's.
 */
function TimePasses({ onPass }) {
  return (
    <section className={styles.section} aria-label="Time">
      <h3 className={styles.caption}>Time</h3>
      <div className={styles.tools}>
        <button
          type="button"
          className={common.btnSmall}
          data-testid="time-passes"
          title="A round's worth of time for everyone: timed conditions count down, fires burn. One undo takes it back."
          onClick={onPass}
        >
          Time passes
        </button>
      </div>
    </section>
  );
}

/**
 * @param {object} props
 * @param {object} props.story - useShellStory's
 * @param {object[]} [props.people], [props.channels] - who a clock may be shown to (the vox's people and groups)
 */
export default function StoryColumn({ story, people = [], channels = [] }) {
  // The vox, when there is a table to speak to: the Announce box sends through it.
  const vox = useChatContext();
  return (
    <div className={styles.column} data-testid="story-column">
      <CastPanel cast={story.cast} canDirect={story.canDirect} />
      <BoardPanel board={story.board} canDirect={story.canDirect} />
      <ClocksPanel
        clocks={story.clocks}
        canDirect={story.canDirect}
        people={people}
        channels={channels}
        entries={story.board.entries}
      />
      {story.canDirect && vox?.send && <Announce send={vox.send} />}
      {story.canDirect && <TimePasses onPass={story.passTime} />}
      {story.canDirect && <TimerControl timer={story.timer} />}
      <GmNotes notes={story.notes} />
    </div>
  );
}
